module.exports = __webpack_public_path__ + "static/media/music.3a376a79.svg";